import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import './aem.css';
import AemLayout from '@dbi-tools/ecommerce-aem-kit/lib/layout';

import { AEM_ROUTE_ERROR } from './const';
import { useAemRoute } from './use-aem-route';
import ErrorView from './error-view';
import { SiteLoader } from '../shared/components/SiteLoader/SiteLoader';

const AemContainer = styled.div`
    *,
    ::after,
    ::before {
        box-sizing: border-box;
    }

    p {
        font-family: 'Objektiv';
    }

    span {
        font-family: 'Objektiv Mk2 Bold';
    }
`;

const AemRoute = ({ pathnameCustom = '', childNode = '' }) => {
    const { pageData, isLoading, routeError, pathname } = useAemRoute({
        pathnameCustom,
    });

    if (isLoading) {
        return <SiteLoader />;
    } else if (pageData && !routeError) {
        return (
            <AemContainer>
                <AemLayout
                    {...{
                        ...pageData,
                        childNode,
                        error: ErrorView,
                        routerLink: Link,
                        pathnameCustom,
                        pathname,
                    }}
                />
            </AemContainer>
        );
    }

    return (
        <ErrorView>
            <h1>{AEM_ROUTE_ERROR.INTERNAL_ERROR}</h1>
        </ErrorView>
    );
};

export default AemRoute;
